import {isEmpty} from 'lodash';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

export const OTHER_INFORMATION_SOURCE = {id: 7, name: "Other", specify: true};

@Injectable()
export class SourcesService {
    constructor(private http: Http) {
    }

    private informationSources: Array<any>;
    private allInformationSources: Array<any>;

    getSources(): Observable<Array<any>> {
        if (isEmpty(this.informationSources)) {
            return this.http.get('/api/client/dictionary/information_sources')
                .map(response => response.json())
                .map(response => {
                    this.informationSources = response.informationSources;
                    return this.informationSources;
                });
        } else {
            return Observable.of(this.informationSources);
        }
    }

    getAllInformationSources(): Observable<Array<any>> {
        if (isEmpty(this.allInformationSources)) {
            return this.http.get('/api/client/dictionary/information_sources?all')
                .map(response => response.json())
                .map(response => {
                    this.allInformationSources = response.informationSources;
                    return this.allInformationSources;
                });
        } else {
            return Observable.of(this.allInformationSources);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/sources.service.ts